import { createFileRoute } from '@tanstack/react-router'
import { HomePage } from '@/pages/HomePage'

const App = () => {
  return <HomePage />
}

export const Route = createFileRoute('/')({
  staticData: {
    headerLight: true,
  },
  component: App,
})
